import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "Modal",
  initialState: null,
  reducers: {
    setModalData: (state, action) => action.payload,
  },
});

export const { setModalData } = modalSlice.actions;
export const modal = modalSlice.reducer;
